import Vue from 'vue'


Vue.filter('amt', function(v) {
    // var pattern = /(?=((?!\b)\d{3})+$)/g;
    // return Number(v).toFixed(2)

    if (v && v != null) {
        v = String(v);
        var left = v.split('.')[0], right = v.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        return (Number(v) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
    } else if (v === 0) {
        return '0.00';
    } else {
        return '';
    }
})

// 0->待处理；1->退货中；2->退款中；3->已完成；4->已拒绝；5->已取消；
// 售后状态(列表)
Vue.filter('shouhouStatus', function(v) {
    if (v == 0) {
        return '等待卖家确认'
    } else if (v == 1) {
        return '退货中'
    } else if (v == 2) {
        return '退款申请中'
    } else if (v == 3) {
        return '已退款'
    } else if (v == 4) {
        return '已拒绝'
    } else if (v == 5) {
        return '已取消'
    } else {
        return v
    }
})


Vue.filter('orderDetailStatus', function(v) {
    if (v == 0 || v == 1) {
        return '待付款'
    } else if (v == 2) {
        return '已付款'
    } else if (v == 3) {
        return '已发货'
    } else if (v == 4) {
        return '交易成功'
    } else if (v == 5) {
        return '无效订单'
    } else {
        return v
    }
})

Vue.filter('fmtTimeStamp', function(v) {
    let time = new Date(v)
    let pattern = undefined
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
})

// 格式化为"#,##0.00##"
Vue.filter('price', function(v) {
    if (v == null)
        return '';
    if (v.toString().indexOf(',') > -1) {
        let arr = v.toString().split(',')
        let a = ''
        for (let i = 0; i < arr.length; i++) {
            a += arr[i]
        }
        v = a
    }
    if (parseFloat(v).toFixed(4).split('.').length <= 1)
        return v;
    var decimalDigits = 2;
    var arr = parseFloat(v).toFixed(4).split('.');

    if (arr[1].charAt(3) == '0') {
        if (arr[1].charAt(2) != '0') {
            decimalDigits = 3;
        }
    } else {
        decimalDigits = 4;
    }
    var info = parseFloat(v).toFixed(decimalDigits).split('.');
    v = info[0];
    let _f = false
    if (v.indexOf('-') > -1) {
        v = info[0].slice(1, v.length)
        _f = true
    }
    var result = '';
    while (v.length > 3) {
        result = ',' + v.slice(-3) + result;
        v = v.slice(0, v.length - 3);
    }
    if (v) {
        result = v + result;
    }
    if (_f) {
        result = '-' + result
    }
    info[0] = result;
    return info.join('.');
})



// WEBPACK FOOTER //
// ./src/common/js/filter/filter.js